import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  const features = ['Sin adivinar temperaturas.', 'Sin desperdiciar materiales.', 'Sin no saber cuánto cobrar.'];
  return <section className="bg-brand-bg py-14" data-id="element-122">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-text" data-id="element-125">
            LA SOLUCIÓN
          </h2>

          <p className="text-xl md:text-2xl text-brand-subtext leading-relaxed mb-8 font-heading" data-id="element-126">
            La Academia de Velas Aromáticas de Casa Calma Candle es un sistema
            paso a paso en PDF imprimible que te lleva de cero a tu primera vela
            vendible en 7 días.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-127">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-brand-alt p-6 rounded-2xl border border-brand-line/30" data-id="element-128">
                <p className="font-semibold text-brand-text text-lg" data-id="element-129">
                  {feature}
                </p>
              </motion.div>)}
          </div>

          <p className="text-lg text-brand-subtext" data-id="element-130">
            Con un plan claro, herramientas de registro y descripciones de venta
            listas para publicar.
          </p>
        </motion.div>
      </div>
    </section>;
}